import { useEffect } from "react";
import { useThemeStore } from "@/app/store/theme.store";

export function ThemeProvider({ children }) {
  const { theme, density, syncSystemTheme } = useThemeStore();

  useEffect(() => {
    // Follow the OS live: someone on "system" who flips their laptop to dark
    // at sunset should not have to reload.
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener("change", syncSystemTheme);
    return () => mq.removeEventListener("change", syncSystemTheme);
  }, [syncSystemTheme]);

  useEffect(() => {
    const dark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
    document.documentElement.classList.toggle("dark", dark);
  }, [theme]);

  useEffect(() => {
    document.documentElement.classList.remove("density-compact", "density-comfortable");
    document.documentElement.classList.add(`density-${density}`);
  }, [density]);

  return children;
}
